import { render, staticRenderFns } from "./builder.vue?vue&type=template&id=0d3059b3&scoped=true&"
import script from "./builder.vue?vue&type=script&lang=js&"
export * from "./builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3059b3",
  null
  
)

export default component.exports